export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-5.762b6616.svg";